import React from 'react';
import { REQUIRES_PAPERWORK } from 'src/common/constants';
import Accordion from 'src/components/common/Accordion/Accordion';
import './RequiresPaperwork.scss';

const RequiresPaperwork: React.FC = () => {
  return (
    <>
      <div className="b-grid requires-paperwork-container">
        <div className="content-left b-typography-sans-serif--body--200 b-font-weight-light b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:8-col b-lg:8-col">
          <p className="requires-paperwork-paragraph">
            You&#39;ll need to complete paperwork to transfer the assets to the account
            because your firm may not be enrolled in an electronic service for investment
            transfers. Before signing the form, contact your other firm to find out if it
            requires a <a href="#">Medallion signature guarantee (MSG)</a>. Mail your
            completed form with a recent account statement (dated within the past 90 days)
            to the T. Rowe Price address provided on the form.
          </p>
          <p className="requires-paperwork-paragraph">
            Note: T. Rowe Price will not initiate your transfer until we receive your
            paperwork. If you choose not to complete this paperwork, no further action is
            required.
          </p>
          <p className="requires-paperwork-paragraph">
            A copy of your form is also available in your secure Message Center on
            troweprice.com. If you&#39;re new to T. Rowe Price, you&#39;ll need to log in
            and complete your account setup to access your Message Center.
          </p>
        </div>
        <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:4-col b-lg:4-col">
          <div className="faq-container">
            <Accordion items={REQUIRES_PAPERWORK} />
          </div>
        </div>
      </div>
    </>
  );
};

export default RequiresPaperwork;
